import React, { useState, useContext, useEffect } from "react";
import PropTypes from "prop-types";
import Modal from "../../Elements/Modal/Modal";
import MainButton from "../../Elements/MainButton/MainButton";
import SecondButton from "../../Elements/SecondButton/SecondButton";
import { AuthContext } from "../../../context/AuthContext";

import walletIcon from "../../../assets/cart/wallet.png";
import applePayIcon from "../../../assets/cart/apple-pay.png";
import googlePayIcon from "../../../assets/cart/google-pay.png";
import stripeIcon from "../../../assets/cart/stripe.png";

import "./PaymentModal.css";

const PaymentModal = ({ isOpen, onClose, onConfirm, wallet, loading, onlyWallet }) => {
  const { token, authLoading } = useContext(AuthContext);
  const isLoggedIn = !!token;
  const [selectedMethod, setSelectedMethod] = useState(null);

  useEffect(() => {
    if (isOpen) {
      if (onlyWallet) {
        setSelectedMethod("wallet");
      } else {
        setSelectedMethod(isLoggedIn && wallet ? "wallet" : "stripe");
      }
    }
  }, [isOpen, isLoggedIn, wallet, onlyWallet]);

  const methodsCount = onlyWallet ? 1 : isLoggedIn ? 4 : 3;

  if (!isOpen || authLoading) {
    return null;
  }

  return (
    <Modal
      isOpen={isOpen}
      onClose={loading ? undefined : onClose}
      title={onlyWallet ? "Pay with Wallet" : "Selected Payment Method"}
      actions={
        <>
          <SecondButton onClick={onClose}>Cancel</SecondButton>
          <MainButton onClick={() => onConfirm(selectedMethod)} disabled={!selectedMethod || loading} loading={loading}>
            {loading ? "Processing..." : "Continue to Pay"}
          </MainButton>
        </>
      }
    >
      <section className="payment-panel">
        <p className="payment-panel__subtitle">Enjoy an instant 3% discount when paying with your wallet balance.</p>
        <div
          className={`payment-methods-row ${loading ? "disabled-area" : ""}`}
          style={{
            opacity: loading ? 0.5 : 1,
            pointerEvents: loading ? "none" : "auto",

            display: "grid",
            gridTemplateColumns: onlyWallet ? "120px" : `repeat(${methodsCount}, 1fr)`,
          }}
        >
          {/* Wallet */}
          {isLoggedIn && wallet ? (
            <button
              type="button"
              className={`payment-method-tile ${selectedMethod === "wallet" ? " payment-method-tile--active" : ""}`}
              onClick={() => setSelectedMethod("wallet")}
            >
              <img
                src={walletIcon}
                alt="Wallet"
                className="payment-method-tile__icon payment-method-tile__icon--wallet"
              />
              <span className="payment-method-tile__label">Wallet</span>
              {/* 🆕 Wyświetl balance */}
            </button>
          ) : null}

          {!onlyWallet && (
            <>
              {/* Stripe */}
              <button
                type="button"
                className={`payment-method-tile ${selectedMethod === "stripe" ? " payment-method-tile--active" : ""}`}
                onClick={() => setSelectedMethod("stripe")}
              >
                <img src={stripeIcon} alt="Stripe" className="payment-method-tile__icon" />
              </button>

              {/* Apple Pay */}
              {/* <button
                type="button"
                className={`payment-method-tile ${selectedMethod === "apple" ? " payment-method-tile--active" : ""}`}
                onClick={() => alert("Apple Pay coming soon!")}
              >
                <img src={applePayIcon} alt="Apple Pay" className="payment-method-tile__icon" />
              </button> */}

              {/* Google Pay */}
              {/* <button
                type="button"
                className={`payment-method-tile ${selectedMethod === "google" ? " payment-method-tile--active" : ""}`}
                onClick={() => alert("Google Pay coming soon!")}
              >
                <img src={googlePayIcon} alt="Google Pay" className="payment-method-tile__icon" />
              </button> */}
            </>
          )}
        </div>
      </section>
    </Modal>
  );
};

PaymentModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onConfirm: PropTypes.func.isRequired,
  wallet: PropTypes.object,
  loading: PropTypes.bool,
};

export default PaymentModal;
